<div class="question-wrapper player-common-component">

  <div class="space-wrapper"></div>

  <div class="content" *ngIf="question">
    <div class="title" *ngIf="question.title">{{question.title}}</div>

    <div *ngIf="question.required || question.isMultiSelect" class="required">{{getConditionText()}}</div>
    <div class="select" *ngIf="question.type == 'QuestionSelect'">
      <ul [attr.class]="decideRowNum(question)">
        <ng-container *ngIf="!question.isMultiSelect">
          <li *ngFor="let option of question.options">
            <span [class.selected]="option.key == question.value"
                  (click)="selected(option)">{{option.value}}</span>
          </li>
        </ng-container>
        <ng-container *ngIf="question.isMultiSelect">
          <li *ngFor="let multiSelectOptionWrapper of multiSelectOptionWrapperList">
            <span [class.selected]="multiSelectOptionWrapper.isSelected"
                  (click)="selected(multiSelectOptionWrapper.option)">{{multiSelectOptionWrapper.option.value}}</span>
          </li>
        </ng-container>
      </ul>
      <div class="btn-wrapper">
        <div class="btn left" [class.hidden]="!hasBack"><button type="button" class="link" (click)="back()"><mat-icon>chevron_left</mat-icon><span>戻る</span></button></div>
        <div class="btn" [class.hidden]="!question.isMultiSelect">
          <button 
            [class.disabled]="(question.required && (question.value == null || question.value == '')) || (question.isMultiSelect && (question.value == null || question.value == ''))" 
            (click)="done()"
            >決定</button>
        </div>
        <div class="btn right" [class.hidden]="question.required"><button type="button" class="link" (click)="skip()"><span>スキップ</span><mat-icon>chevron_right</mat-icon></button></div>
      </div>
    </div>

    <div class="textarea" *ngIf="question.type == 'QuestionText'">
      <div class="textarea-wrapper">
        <mat-form-field appearance="outline">
          <mat-label>テキストを入力</mat-label>
          <textarea matInput [(ngModel)]="question.value"></textarea>
          <mat-hint>1000文字以内</mat-hint>
        </mat-form-field>
      </div>
      <div class="btn-wrapper">
        <div class="btn left" [class.hidden]="!hasBack"><button type="button" class="link" (click)="back()"><mat-icon>chevron_left</mat-icon><span>戻る</span></button></div>
        <div class="btn"><button [class.disabled]="(question.required && (question.value == null || question.value == ''))" (click)="done()">決定</button></div>
        <div class="btn right" [class.hidden]="question.required"><button type="button" class="link" (click)="skip()"><span>スキップ</span><mat-icon>chevron_right</mat-icon></button></div>
      </div>
    </div>

    <div class="rating" *ngIf="question.type == 'QuestionRating'">
      <div class="step-texts">
        <div class="step-text">{{question.lowerText}}</div>
        <div class="step-text">{{question.higherText}}</div>
      </div>
      <ul>
        <li *ngFor="let step of question.steps" (click)="rated(step)"
            [class.selected]="step == question.value">
          <span>{{step}}</span>
        </li>
      </ul>
      <div class="btn-wrapper">
        <div class="btn left"  [class.hidden]="!hasBack"><button type="button" class="link" (click)="back()"><mat-icon>chevron_left</mat-icon><span>戻る</span></button></div>
        <div class="btn right" [class.hidden]="question.required"><button type="button" class="link" (click)="skip()"><span>スキップ</span><mat-icon>chevron_right</mat-icon></button></div>
      </div>
    </div>
  </div>

  <div class="controls-wrapper">
    <div class="back-forward">
      <div class="back btn show" *ngIf="question.replay" (click)="backToTopClicked()">
        <mat-icon class="material-icons-rounded">replay</mat-icon>最初に戻る
      </div>
    </div>
  </div>

</div>
